import { ChartsDateRange } from "@/app/admin/AdminChartsPage/components/DateRangeControls/DataRangeControls";
import { API } from "@/lib/api";
import { AdminGetBatchesResponse, AdminGetUsersResponse, FBA_API_VERSION, GetAdminMirrorJwtResponse } from "@boxem/core-api-schema";

export async function getUsers(offset: number, limit: number, term?: string): Promise<AdminGetUsersResponse> {
  const params = new URLSearchParams();
  params.append('offset', offset.toString());
  params.append('limit', limit.toString());
  if (!!term) {
    params.append('searchTerm', term);
  }

  return await API.get<AdminGetUsersResponse>(`${FBA_API_VERSION}/admin/users`, params);
};

export async function getAdminMirrorJwt(uuid: string): Promise<GetAdminMirrorJwtResponse> {
  const params = new URLSearchParams();
  params.append('uuid', uuid);

  return await API.get<GetAdminMirrorJwtResponse>(`${FBA_API_VERSION}/admin/users/mirror-jwt`, params);
};

export async function getAdminBatches(range: ChartsDateRange): Promise<AdminGetBatchesResponse> {

  const allBatches: AdminGetBatchesResponse = {
    batches: [],
  };

  const recurseFetchAllBatches = async (offset: number) => {
    const params = new URLSearchParams();
    const limit = 5000; //Should be ok since we're only getting back a subset of the batch and its shipments.
    params.append('offset', offset.toString());
    params.append('limit', limit.toString());
    params.append('range', range);

    try {
      const batches = await API.get<AdminGetBatchesResponse>(`${FBA_API_VERSION}/admin/batches`, params);

      allBatches.batches = [...allBatches.batches, ...batches.batches];

      if (batches.batches.length !== limit) {
        return;
      }

      return recurseFetchAllBatches(offset + limit);
    } catch (err) {
      throw new Error("Failed to fetch all batches for admin", err);
    }
  };

  await recurseFetchAllBatches(0);

  return allBatches;
};

export async function getAdminUsers(range: ChartsDateRange): Promise<AdminGetUsersResponse> {
  const allUsers: AdminGetUsersResponse = {
    users: [],
    count: 0,
  };

  const recurseFetchAllUsers = async (offset: number) => {
    const params = new URLSearchParams();
    const limit = 500; //Should be ok since we're only getting back a subset of the user.
    params.append('offset', offset.toString());
    params.append('limit', limit.toString());
    params.append('range', range);

    try {
      const users = await API.get<AdminGetUsersResponse>(`${FBA_API_VERSION}/admin/users`, params);

      allUsers.users = [...allUsers.users, ...users.users];

      if (users.users.length !== limit) {
        return;
      }

      return recurseFetchAllUsers(offset + limit);
    } catch (err) {
      throw new Error("Failed to fetch all users for admin", err);
    }
  };

  await recurseFetchAllUsers(0);

  return allUsers;
};